import { Controller } from "@hotwired/stimulus"

// The phone/mobile/fax columns are a single string, but the UI shows an editable
// dialing-code box + a number box. On connect we split the stored value into the
// two boxes; on any edit we join them back into the hidden field that actually
// submits. An empty number stores nothing (never a lone "+49").
// A page that split the value on the server (PhoneNumber.split knows where a
// country code ends; "+491701234567" read here as "+4917") sets `split` (QA).
export default class extends Controller {
  static targets = ["code", "number", "hidden"]
  static values = { split: Boolean }

  connect() {
    if (this.splitValue) return this.sync()

    const value = (this.hiddenTarget.value || "").trim()
    const match = value.match(/^(\+\d{1,4})\s*(.*)$/)
    if (match) {
      this.codeTarget.value = match[1]
      this.numberTarget.value = match[2]
    } else if (value) {
      this.numberTarget.value = value
    }
    this.sync()
  }

  sync() {
    const code = this.codeTarget.value.trim()
    const number = this.numberTarget.value.trim()
    this.hiddenTarget.value = number ? [code, number].filter(Boolean).join(" ") : ""
  }
}
